import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * Monad liquid-staking tokens — intrinsic staking APR from DefiLlama.
 *
 * Single-pool LSTs whose `apy` == `apyBase` (no incentive layer on the
 * LST itself):
 *   - sMON  — Kintsu Staked Monad (`kintsu` project)
 *   - shMON — ShMonad (`shmonad` project)
 *   - gMON  — Magma staked MON (`magma-staking` project)
 *
 * aprMON (aPriori) has no DefiLlama pool — its rate comes from the
 * on-chain ERC-4626 exchange rate instead, so it's intentionally absent.
 *
 * Each pool is fetched independently so one outage doesn't drop the others.
 */
const SMON_POOL_ID = '73c511a9-4dc0-4397-babe-e578fd75f0dd'
const SHMON_POOL_ID = 'ee40513c-9356-4c53-9f26-446b484a8ae2'
const GMON_POOL_ID = '96f74061-dc9a-4ef7-8117-6cd3935230de'

/** Shared keys — match the respective registry entries' `yieldKey`. */
const SMON_KEY = 'Kintsu Staked Monad::sMON'
const SHMON_KEY = 'ShMonad::shMON'
const GMON_KEY = 'gMON::gMON'

export const monadLstFetcher: YieldFetcher = {
  label: 'MONAD_LST',
  fetch: async () => {
    const [sMon, shMon, gMon] = await Promise.allSettled([
      fetchDefiLlamaApy(SMON_POOL_ID),
      fetchDefiLlamaApy(SHMON_POOL_ID),
      fetchDefiLlamaApy(GMON_POOL_ID),
    ])
    // DefiLlama reports a compounded APY; the pipeline keys on APR, so
    // convert (matches berapaw/dinero and the rest of the fetchers).
    const out: { [asset: string]: number } = {}
    if (sMon.status === 'fulfilled') out[SMON_KEY] = apyToAprPercent(sMon.value)
    if (shMon.status === 'fulfilled')
      out[SHMON_KEY] = apyToAprPercent(shMon.value)
    if (gMon.status === 'fulfilled') out[GMON_KEY] = apyToAprPercent(gMon.value)
    return out
  },
}
